import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import DashboardListCard from 'modules/common/dashboard/DashboardListCard';
import CedulaDashboardContainer from './containers/CedulaDashboardContainer';
import * as actions from './action';
import * as c from './constant';

const getList = (data) => [
  // {
  //   label: 'Received',
  //   value: _.get(data, 'RECEIVED', 0),
  //   borderClassName: 'paid',
  // },
  {
    label: 'Issued',
    value: _.get(data, 'ISSUED', 0),
    borderClassName: 'paid',
  },
  {
    label: 'For Pickup',
    value: _.get(data, 'FOR PICK-UP', 0),
    borderClassName: 'pickup',
  },
  {
    label: 'For Printing',
    value: _.get(data, 'FOR PRINTING', 0),
    borderClassName: 'paid',
  },
  {
    label: 'Waiting for Payment',
    value: _.get(data, 'WAITING FOR PAYMENT', 0),
    borderClassName: 'waiting',
  },
  {
    label: 'For Payment Confirmation',
    value: _.get(data, 'FOR PAYMENT CONFIRMATION', 0),
    borderClassName: 'paid',
  },
  {
    label: 'For Payment',
    value: _.get(data, 'PENDING', 0),
    borderClassName: 'checking',
  },
  {
    label: 'For Evaluation',
    value: _.get(data, 'FOR CHECKING', 0),
    borderClassName: 'rejected',
  },
  {
    label: 'Revoked',
    value: _.get(data, 'REVOKED', 0),
    borderClassName: 'rejected',
  },
  {
    label: 'For Resubmission',
    value: _.get(data, 'FOR RESUBMISSION', 0),
    borderClassName: 'pickup',
  },
  {
    label: 'Expired Reference Number',
    value: _.get(data, 'EXPIRED REFERENCE NUMBER', 0),
    borderClassName: 'received',
  },
  {
    label: 'Cancelled',
    value: _.get(data, 'CANCELLED', 0),
    borderClassName: 'received',
  },
];

function TransactionsContainer({ totalStats, getTotalStats }) {
  const returnIndividualTransactionData = () => {
    const data = _.get(totalStats, 'item.total_individual_cedula_statuses');
    return {
      label: 'Individual',
      total: _.get(totalStats, 'item.total_individual_cedula', 0),
      // photo: ''
      list: getList(data),
    };
  };
  const returnCorporationTransactionData = () => {
    const data = _.get(totalStats, 'item.total_corporation_cedula_statuses');
    return {
      label: 'Corporation',
      total: _.get(totalStats, 'item.total_corporation_cedula', 0),
      // photo: ''
      list: getList(data),
    };
  };

  useEffect(() => {
    getTotalStats();
  }, []);

  return (
    <div className="container-fluid mb-3">
      <div className="row">
        <div className="col-4 pl-0">
          <DashboardListCard
            data={returnIndividualTransactionData()}
            className="mb-3"
          />
          <DashboardListCard data={returnCorporationTransactionData()} />
        </div>
        <div className="col-8 pr-0">
          <CedulaDashboardContainer />
        </div>
      </div>
    </div>
  );
}

TransactionsContainer.propTypes = {
  totalStats: PropTypes.instanceOf(Object).isRequired,
  getTotalStats: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  totalStats: _.get(api, `${c.GET_TOTAL_STATS}`) || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(TransactionsContainer);
